import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContestProposalComment } from "../../../../../../redux/contest/action";
import { getTimeandhours } from "../../../../../Common/AllDateTimeReleventFormate";
import getTimeDifference from "../../../../../Common/TimeDifference";

export default function ModelCommentList({ id, item }) {
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(5);
  const dispatch = useDispatch();
  const gcpcl = useSelector(
    ({ contest: { getcontestmodelcommentlist } }) => getcontestmodelcommentlist,
  );

  useEffect(() => {
    if (item.id != null) {
      setLoading(true);
      dispatch(getContestProposalComment(item.id, size)).finally(() =>
        setLoading(false),
      );
    }
  }, [dispatch, item?.id, size]);

  const handleLoadMore = () => {
    setSize((prevSize) => prevSize + 5);
  };

  return (
    <div className="modal-comment">
      {Array.isArray(gcpcl?.response) && gcpcl?.response?.length > 0 && (
        <>
          <h4>All Comments</h4>
          {gcpcl?.response.map((comment, index) => (
            <div className="comment-sec" key={index}>
              <img src={comment?.profile_image} alt="" />
              <div className="w-100">
                <div className="profile-sec">
                  <h6>
                    {comment.first_name} {comment.last_name}
                  </h6>
                  <p>{getTimeDifference(comment?.created_on)}</p>
                </div>
                <p>{comment.message}</p>
              </div>
            </div>
          ))}
          {gcpcl?.count > gcpcl?.response?.length ? (
            <button className="btn" onClick={handleLoadMore} disabled={loading}>
              {loading ? "Loading..." : "View More Comments"}
            </button>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
}
